// import { Box, Button, Typography, Modal, Grid } from "@mui/material";

import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormControl,
  Container,
  Grid,
  Box,
  Stack,
  OutlinedInput,
  InputLabel,
  MenuItem,
  ListItemText,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Modal,
  DialogTitle,
  Tabs,
  Tab,
  Switch,
  FormGroup,
  Typography,
  Divider,
  DialogContent,
  DialogActions,
  IconButton,
  InputAdornment,
} from "@mui/material";

import {
  addEmployee,
  getNewSubscriptionReachageDetails,
  updateEmployee,
} from "./appoinmentDashboardApi";
import { payloadDateFormat, swalAlertPopProps } from "../../utils/commonUtils";
import { getDataRechageDetail } from "./smbAccountRechargeCustomApiHandler";
import { getMonthDifference } from "./smbAccounrReachargeDateFunction";
import CloseIcon from "@mui/icons-material/Close";
import { getAlldetailSerice } from "../services/servicesListApi";

// import "./test.css";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { bookApoinment } from "./asppoinmentApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { routePath } from "../../constants/routePath";
import { setSession } from "../../utils/commonUtils";
import { setCustomerAppointmentId } from "../../app/store/reducer";
// import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { validationPersonalInfo } from "../payment/validation";
import Swal from "sweetalert2";
import { ModalHeader } from "../../common/modalHeader";
// import { getAlldetailSerice } from "../services/servicesListApi";
import calendar from "../../assets/icon/calendarblack.png";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function FormModal({
  open,
  setOpen,
  modalData,
  setModalData,
  getAll,
}) {
  const [pagination, setPagination] = useState({ page: 1, total: 10 });
  const [subscription, setSubscription] = useState();
  const [value, setValue] = React.useState("personalInfo");

  const handleChange_Tab = (event, newValue) => {
    // setPageNo(1);

    setValue(newValue);
  };

  const onClose = () => {
    setOpen(false);
    setTabValue("");
  };

  const struct = {
    billerId: "",
    employeeId: "",
    employeeName: "",
    alternateMobileNumber: "",
    customerName: "",
    mobileNumber: "",
    designation: "",
    pan: "",
    address: "",
    email: "",
    aadhar: "",

    paymentPercentage: "",
    // otp: "",
    mailId: "",
    gender: "",
    bankName: "",
    bankAccountNumber: "",
    bankBranch: "",
    service: "",
    salary: "",

    deduction: "",
    date: "",
    ifsc: "",
    hour: "",
    minute: "",
    isActive: true,
  };
  const appnType = useSelector((state) => state.reducer.apppoinmentUerType);
  const dispatch = useDispatch();
  const info = useSelector((state) => state.reducer.detail);
  const [formData, setFormData] = useState({ ...struct });

  useEffect(() => {
    console.log("formate date  ", timeValue);
    console.log("ppoinment22 ", info);
  }, [formData]);
  const [dateValue, setDateValue] = useState();
  const [dateValuet, setDateValuet] = useState();

  const [timeValue, setTimeValue] = useState(dayjs());
  const [otpEnabled, setOtpEnabled] = useState(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const regex = /^[a-zA-Z\s]*$/;
    // console.log()
    if (name == "employeeName" && !regex.test(value)) {
      setFormData({
        ...formData,
        [name]: value[0],
      });
    } else if (typeof value == "object") {
      setFormData({
        ...formData,
        [name]: value[0],
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const setDate = (newValue) => {
    setDateValue(newValue);

    // const date = dayjs(newValue).tz('UTC').format('YYYY-MM-DDTHH:mm:ss.SSZ');

    // console.log("date ",date)

    const date = dayjs(newValue).tz("UTC").format("YYYY-MM-DDTHH:mm:ss");

    console.log("date", date);

    // console.log("data ",date)
    setFormData((prev) => {
      return { ...prev, doj: date };
      // return {...prev,date:date}
    });
  };

  const setDatet = (newValue) => {
    setDateValuet(newValue);

    // const date = dayjs(newValue).tz('UTC').format('YYYY-MM-DDTHH:mm:ss.SSZ');

    // console.log("date ",date)

    const date = dayjs(newValue).tz("UTC").format("YYYY-MM-DDTHH:mm:ss");

    console.log("date", date);

    // console.log("data ",date)
    setFormData((prev) => {
      return { ...prev, dob: date };
      // return {...prev,date:date}
    });
  };

  const setTime = (newValue) => {
    setFormData((prev) => {
      if (newValue["$H"] == 20) {
        prev.hour = newValue["$H"] + 12;
      } else {
        prev.hour = newValue["$H"];
      }
      prev.minute = newValue["$m"];
      return { ...prev };
    });
    setTimeValue(newValue);
  };

  const handleTagsChange = (e) => {
    const { value } = e.target;

    console.log("val8e ", value);
    setFormData({
      ...formData,
      service: value,
    });
  };

  const gender = (e) => {
    setFormData((prev) => {
      let temp = { ...prev };
      if (e.target) {
        temp.gender = e.target.value;
      } else {
        temp.gender = e;
      }
      return { ...temp };
    });
  };
  const [tabVale, setTabValue] = useState("");
  const tabFn = (e) => {
    setTabValue(e.target.value);
  };
  const handleVerifymobileNumber = () => {
    if (formData.mobileNumber) {
      setOtpEnabled(true);
    }
  };
 const validateForm = (formData, tabVale) => {
  
   if (!formData.employeeName?.trim())
     return { status: false, text: "Employee name is required" };
   if (!/^\d{10}$/.test(formData.mobileNumber))
     return { status: false, text: "Enter a valid 10-digit mobile number" };
   if (!formData.address?.trim())
     return { status: false, text: "Address is required" };
   if (!formData.gender) return { status: false, text: "Gender is required" };

    if (!tabVale)
      return {
        status: false,
        text: "Please select Salary",
     };
   
     if (tabVale === "PaymentPercentage") {
       if (
         !formData.paymentPercentage ||
         formData.paymentPercentage.trim() === ""
       )
         return {
           status: false,
           text: "Payment Percentage is required",
         };
     }


   return { status: true };
 };



  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(appnType, "appnType");
 let valid = validateForm(formData, tabVale);

    if (valid?.status == false) {
      Swal.fire({
        text: valid.text,
        icon: "warning",
        ...swalAlertPopProps,
      });
      setValidationMsgFlag(true);
      // setOpen(false);

      // return;
    } else {
      // setValidationMsgFlag(null)
      let tempOb = {
        id: 1091,
        name: "Ramnivas",
        address: "Wakad",
        mobile: "9454546558",
        paymentPercentage: 0.0,
        isActive: false,
        alternateMobile: null,
        gender: "Male",
        email: null,
        pan: null,
        salary: 0.0,
        doj: null,
        dob: null,
        designation: null,
        employeeId: null,
        aadhar: null,
        deduction: 0.0,
        bankName: null,
        bankAccountNumber: null,
        bankBranch: null,
        ifsc: null,
        grade: null,
        specialization: null,
        achievements: null,
        profileImageFile: null,
        profileImagePath:
          "https://elegantprime.in/profileimages/73c578fc-f8b5-4c39-ab29-7a922dd84451.jpg",
        skillSet: null,
        overview: null,
      };
      const payload = {
        // Id: 0,
        Name: formData.employeeName,
        // EmployeeName: formData.employeeName,
        // employeeName: formData.employeeName,
        Address: formData.address,
        Email: formData.email,
        Aadhar: formData.aadhar,
        BankName: formData?.bankName,
        BankAccountNumber: formData?.bankAccountNumber,
        BankBranch: formData?.bankBranch,
        Mobile: formData.mobileNumber,
        Grade: formData?.grade,
        Ifsc: formData.ifsc,
        PaymentPercentage: parseFloat(
          formData.paymentPercentage ? formData.paymentPercentage : 0.0
        ),
        IsActive: formData.isActive,

        AlternateMobile: formData.alternateMobileNumber,

        Deduction: parseFloat(formData.deduction ? formData.deduction : 0.0),

        // IsActive: formData.isActive,
        Gender: formData.gender,

        Pan: formData.pan,
        salaryorPercentage: tabVale == "salary" ? true : false,
        // "salary": 0,
        Doj: formData?.doj ? formData?.doj : "",

        Dob: formData?.dob ? formData?.dob : "",
        Designation: formData?.designation,
        EmployeeId: formData?.employeeId,
        aadhar: formData?.aadhar,
      };
      if (modalData?.id) {
        payload["Id"] = modalData?.id;
      }

      const formDataobj = new FormData();
      Object.keys(payload).forEach((key, index) => {
        formDataobj.append(key, payload[key]);
      });
      const condition = appnType == "profile";

      console.log("formdata", payload, " ", payload?.paymentPercentage);
      if (!formData?.id) {
        addEmployee(formDataobj, () => {
          setOpen(false);
          getAll();
          // console.log("payload",)
        });
      } else {
        updateEmployee(formDataobj, () => {
          console.log("data");
          setOpen(false);
          getAll();
        });
      }
    }
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const [servicesArr, setservicesArr] = useState([
    {
      serviceName: "Shaving",
      rate: "100.00/Per Head",
    },
    {
      serviceName: "Hair cutting",
      rate: "150.00/Per Head",
    },
  ]);
  const [validationMsgFlag, setValidationMsgFlag] = useState(null);

  const names = [
    "Haircut",
    "Hair Coloring",
    "Hair Styling",
    "Manicure",
    "Pedicure",
    "Facial",
    "Waxing",
    "Massage",
    "Makeup",
    "Bridal Makeup",
    "Threading",
    "Hair Spa",
    "Nail Art",
    "Skin Treatment",
  ];
  useEffect(() => {
    setFormData({
      ...formData,
      billerId: info.billerId,
    });
    setDate(timeValue);
    setTime(timeValue);
    gender("male");
  }, []);
  const [isLess, setshowLess] = useState(false);

  const infoD = useSelector((state) => state.reducer.detail);
  useEffect(() => {
    // getAlldetailSerice(
    //   {
    //     billerId: infoD?.billerId,
    //   },
    //   (res) => {
    //     console.log("Data res", res);
    //     setservicesArr(res?.data);
    //   }
    // );
  }, []);
  useEffect(() => {
    if (open === true && modalData) {
      console.log("modalData", modalData);
      setFormData({
        ...formData,

        id: modalData?.id,
        bankName: modalData?.bankName,
        bankAccountNumber: modalData?.bankAccountNumber,
        bankBranch: modalData?.bankBranch,
        employeeId: modalData?.employeeId,
        employeeName: modalData?.name,
        alternateMobileNumber: modalData?.alternateMobile,
        // customerName:modalData?.customerName,
        mobileNumber: modalData?.mobile,
        designation: modalData?.designation,
        pan: modalData?.pan,
        salary: modalData?.salary,
        ifsc: modalData?.ifsc,
        address: modalData?.address,
        paymentPercentage: modalData?.paymentPercentage
          ? String(modalData?.paymentPercentage)
          : "",
        // otp: "",
        dob: modalData?.dob,
        doj: modalData?.doj,
        deduction: modalData?.deduction,
        email: modalData?.email,
        aadhar: modalData?.aadhar,
        gender: modalData?.gender,
        grade: modalData?.grade,
        service: "",

        date: "",
        hour: "",
        minute: "",
        isActive: modalData?.isActive,
      });
      setTabValue(
        modalData.salaryorPercentage ? "salary" : "PaymentPercentage"
      );
      setDateValue(dayjs(modalData?.dob));
      setDateValuet(dayjs(modalData?.doj));

      // setDateValuet()
      // getDataRechageDetail(getNewSubscriptionReachageDetails, setSubscription);
    } else {
      console.log("close");
      // if(!validationMsgFlag){
      setFormData({
        billerId: "",
        employeeId: "",
        employeeName: "",
        alternateMobileNumber: "",
        customerName: "",
        mobileNumber: "",
        designation: "",
        pan: "",
        address: "",
        email: "",
        aadhar: "",

        paymentPercentage: "",
        // otp: "",
        mailId: "",
        gender: "",
        bankName: "",
        bankAccountNumber: "",
        bankBranch: "",
        service: "",
        salary: "",
        deduction: "",
        date: "",
        ifsc: "",
        hour: "",
        minute: "",
        isActive: true,
      });
      setModalData(null);
      // }
    }
  }, [open]);
  useEffect(() => {
    console.log("tabValetabVale ", tabVale);
  }, [tabVale]);
  return (
    <Modal
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth="xs"
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "80%", md: "70%", lg: "50%" },
          overflowY: "auto",
          height: { xs: "80vh", sm: "70vh", md: "72vh", lg: "75vh" },
          position: "absolute",
          borderRadius: "10px",
          left: { xs: "2%", sm: "15%", md: "20%", lg: "25%" },
          top: "10%",
        }}
      >
        <ModalHeader title="Employee Details" onClose={onClose} />
        {/* <DialogTitle
          color="primary"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "auto",
            p: "0px 10px !important",
          }}
        >
          Employee Information{" "}
          <CloseIcon
            sx={{ float: "right", cursor: "pointer" }}
            onClick={() => setOpen(false)}
          />
        </DialogTitle> */}

        <DialogContent sx={{ p: 2, mt: 2 }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2} sx={{ pt: 1 }} alignItems="center">
              <Grid item xs={12} sm={3}>
                <FormControl fullWidth>
                  <TextField
                    label="Employee Id:"
                    name="employeeId"
                    size="small"
                    value={formData.employeeId}
                    onChange={handleChange}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        Employee Name <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="employeeName"
                    size="small"
                    value={formData.employeeName}
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/\b\w/g, (c) =>
                        c.toUpperCase()
                      ))
                    }
                    onChange={handleChange}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        Mobile Number <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="mobileNumber"
                    size="small"
                    value={formData.mobileNumber}
                    onInput={(e) => {
                      let inputValue = e.target.value.replace(/\D/g, "");
                      inputValue = inputValue.slice(0, 10);
                      e.target.value = inputValue;
                    }}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField
                    label={
                      <span>
                        Address <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="address"
                    size="small"
                    value={formData.address}
                    onChange={handleChange}
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/^\w/, (c) =>
                        c.toUpperCase()
                      ))
                    }
                    InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl>
                  <FormLabel
                    id="demo-row-radio-buttons-group-label"
                    className="mulish"
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 600,
                        color: "#01008B",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      Gender <span style={{ color: "red" }}>*</span>
                    </Typography>
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="female"
                      control={<Radio />}
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          Female
                        </Typography>
                      }
                      checked={
                        formData.gender == "female" ||
                        formData.gender == "Female"
                      }
                      className="mulish"
                      onClick={gender}
                    />
                    <FormControlLabel
                      value="male"
                      control={<Radio />}
                      checked={
                        formData.gender == "male" || formData.gender == "Male"
                      }
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          Male
                        </Typography>
                      }
                      className="mulish"
                      onClick={gender}
                    />
                    <FormControlLabel
                      value="other"
                      control={<Radio />}
                      checked={
                        formData.gender == "other" || formData.gender == "Other"
                      }
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          Other
                        </Typography>
                      }
                      className="mulish"
                      onClick={gender}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl>
                  <FormLabel
                    id="demo-row-radio-buttons-group-label"
                    className="mulish"
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 600,
                        color: "#01008B",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      Salary <span style={{ color: "red" }}>*</span>
                    </Typography>
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="salary"
                      control={<Radio />}
                      checked={tabVale == "salary"}
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          Salary
                        </Typography>
                      }
                      className="mulish"
                      onClick={tabFn}
                    />
                    <FormControlLabel
                      value="PaymentPercentage"
                      control={<Radio />}
                      checked={tabVale == "PaymentPercentage"}
                      label={
                        <Typography
                          variant="body2"
                          sx={{
                            whiteSpace: "nowrap",
                            fontWeight: 500,
                            color: "#01008B",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          }}
                        >
                          Payment Percentage
                        </Typography>
                      }
                      className="mulish"
                      onClick={tabFn}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              {tabVale == "PaymentPercentage" && (
                <React.Fragment>
                  <Grid item xs={12} sm={4}>
                    <FormControl fullWidth>
                      <TextField
                        label="Payment Percentage"
                        name="paymentPercentage"
                        size="small"
                        value={formData.paymentPercentage}
                        onChange={(e) => {
                          const inputValue = e.target.value;

                          // Regular expression to allow only numbers and one decimal point
                          const regex = /^[0-9]*\.?[0-9]*$/;

                          // Check if the input matches the regex
                          if (regex.test(inputValue)) {
                            // setValue(inputValue);
                            handleChange(e);
                          }
                        }}
                        InputProps={{
                          className: "mulish",

                          sx: {
                            background: "#fff",
                            borderRadius: 1,
                            cursor: "pointer",
                            fontFamily: "'Montserrat', sans-serif",
                            fontWeight: 500,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          },
                        }}
                        InputLabelProps={{
                          className: "mulish",

                          sx: {
                            color: "#545454",
                            fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            paddingX: "7px",
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControl fullWidth>
                      <TextField
                        label="Deduction :"
                        name="deduction"
                        size="small"
                        value={formData.deduction}
                        onChange={(e) => {
                          const inputValue = e.target.value;

                          // Regular expression to allow only numbers and one decimal point
                          const regex = /^[0-9]*\.?[0-9]*$/;

                          // Check if the input matches the regex
                          if (regex.test(inputValue)) {
                            // setValue(inputValue);
                            handleChange(e);
                          }
                        }}
                        InputProps={{
                          className: "mulish",

                          sx: {
                            background: "#fff",
                            borderRadius: 1,
                            cursor: "pointer",
                            fontFamily: "'Montserrat', sans-serif",
                            fontWeight: 500,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          },
                        }}
                        InputLabelProps={{
                          className: "mulish",

                          sx: {
                            color: "#545454",
                            fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            paddingX: "7px",
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>
                </React.Fragment>
              )}

              <React.Fragment>
                {/* <Grid item xs={12} sm={12}>
                      <FormControl fullWidth>
                        <TextField
                          label="Address"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          onInput={(e) =>
                            (e.target.value = e.target.value.replace(
                              /^\w/,
                              (c) => c.toUpperCase()
                            ))
                          }
                          InputLabelProps={{ className: "mulish" }}
                          InputProps={{ classes: { input: "mulish" } }}
                        />
                      </FormControl>
                    </Grid> */}
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <TextField
                      label="Alternate Mobile Number :"
                      name="alternateMobileNumber"
                      size="small"
                      value={formData.alternateMobileNumber}
                      onInput={(e) => {
                        let inputValue = e.target.value.replace(/\D/g, "");
                        inputValue = inputValue.slice(0, 10);
                        e.target.value = inputValue;
                      }}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      InputProps={{
                        className: "mulish",

                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        className: "mulish",

                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={5}>
                  <FormControl fullWidth>
                    <TextField
                      label="Email :"
                      name="email"
                      size="small"
                      value={formData.email}
                      onChange={handleChange}
                      InputProps={{
                        className: "mulish",

                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        className: "mulish",

                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormControl fullWidth>
                    <TextField
                      label="PAN :"
                      name="pan"
                      size="small"
                      value={formData.pan}
                      onInput={(e) =>
                        (e.target.value = e.target.value
                          .toUpperCase()
                          .replace(/[^A-Z0-9]/g, "")
                          .slice(0, 10))
                      }
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      InputProps={{
                        className: "mulish",

                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        className: "mulish",

                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <TextField
                      label="Aadhaar Card Number :"
                      name="aadhar"
                      size="small"
                      value={formData.aadhar}
                      onChange={(e) => {
                        const inputValue = e.target.value;

                        // Regular expression to allow only numbers and one decimal point
                        const regex = /^[0-9]{0,12}$/;

                        // Check if the input matches the regex
                        if (regex.test(inputValue)) {
                          handleChange(e);
                        }
                      }}
                      InputProps={{
                        className: "mulish",

                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        className: "mulish",

                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <TextField
                      label="Bank Account Number :"
                      name="bankAccountNumber"
                      size="small"
                      value={formData.bankAccountNumber}
                      onChange={handleChange}
                      InputProps={{
                        className: "mulish",

                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        className: "mulish",

                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                {/* <Grid item xs={4}>
                  <FormControl fullWidth>
                    <TextField
                      label="Bank Name :"
                      name="bankName"
                      size="small"
                      value={formData.bankName}
                      onChange={handleChange}
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/\b\w/g, (c) =>
                          c.toUpperCase()
                        ))
                      }
                     InputProps={{
                      className: "mulish",

                      sx: {
                        background: "#fff",
                        borderRadius: 1,
                        cursor: "pointer",
                        fontFamily: "'Montserrat', sans-serif",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      },
                    }}
                    InputLabelProps={{
                      className: "mulish",

                      sx: {
                        color: "#545454",
                        fontWeight: 400,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingX: "7px",
                      },
                    }}
                    />
                  </FormControl>
                </Grid> */}
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <TextField
                      label="Bank Branch :"
                      name="bankBranch"
                      size="small"
                      value={formData.bankBranch}
                      onChange={handleChange}
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/^\w/, (c) =>
                          c.toUpperCase()
                        ))
                      }
                      InputProps={{
                        className: "mulish",

                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        className: "mulish",

                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <TextField
                      label="IFSC Code :"
                      name="ifsc"
                      size="small"
                      value={formData.ifsc}
                      onChange={handleChange}
                      onInput={(e) =>
                        (e.target.value = e.target.value.toUpperCase())
                      }
                      InputProps={{
                        className: "mulish",

                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        className: "mulish",

                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="DOJ :"
                        value={modalData?.id ? dateValue : null}
                        onChange={(newValue) => {
                          setDate(newValue);
                        }}
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                            InputLabelProps: {
                              className: "mulish",
                              sx: {
                                color: "#545454",
                                fontWeight: 400,
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                paddingX: "7px",
                              },
                            },
                            InputProps: {
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton edge="end">
                                    <Box
                                      component="img"
                                      src={calendar}
                                      alt="calendar icon"
                                      sx={{
                                        width: 20,
                                        height: 20,
                                        cursor: "pointer",
                                      }}
                                    />
                                  </IconButton>
                                </InputAdornment>
                              ),
                              classes: { input: "mulish" },
                              sx: {
                                color: "#545454",
                                fontWeight: 400,
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                paddingX: "7px",
                              },
                            },
                            error: false,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="DOB :"
                        value={modalData?.id ? dateValuet : null}
                        onChange={(newValue) => {
                          setDatet(newValue);
                        }}
                        slotProps={{
                          textField: {
                            size: "small",
                            fullWidth: true,
                            InputLabelProps: {
                              className: "mulish",
                              sx: {
                                color: "#545454",
                                fontWeight: 400,
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                paddingX: "7px",
                              },
                            },
                            InputProps: {
                                endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton edge="end">
                                    <Box
                                      component="img"
                                      src={calendar}
                                      alt="calendar icon"
                                      sx={{
                                        width: 20,
                                        height: 20,
                                        cursor: "pointer",
                                      }}
                                    />
                                  </IconButton>
                                </InputAdornment>
                              ),
                              classes: { input: "mulish" },
                              sx: {
                                color: "#545454",
                                fontWeight: 400,
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                paddingX: "7px",
                              },
                            },
                            error: false,
                          },
                        }}
                        InputProps={{
                          className: "mulish",

                          sx: {
                            background: "#fff",
                            borderRadius: 1,
                            cursor: "pointer",
                            fontFamily: "'Montserrat', sans-serif",
                            fontWeight: 500,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          },
                        }}
                        InputLabelProps={{
                          className: "mulish",

                          sx: {
                            color: "#545454",
                            fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            paddingX: "7px",
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                {/* .@@@@@ */}

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <TextField
                      label="Designation :"
                      name="designation"
                      size="small"
                      value={formData.designation}
                      onChange={handleChange}
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/\b\w/g, (c) =>
                          c.toUpperCase()
                        ))
                      }
                      InputProps={{
                        className: "mulish",

                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        className: "mulish",

                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <FormControl fullWidth>
                    <TextField
                      label="Grade :"
                      name="grade"
                      size="small"
                      value={formData.grade}
                      onChange={handleChange}
                      InputProps={{
                        className: "mulish",

                        sx: {
                          background: "#fff",
                          borderRadius: 1,
                          cursor: "pointer",
                          fontFamily: "'Montserrat', sans-serif",
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                      InputLabelProps={{
                        className: "mulish",

                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>

                {modalData?.id && (
                  <Grid item xs={3}>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 500, color: "#01008B" }}
                      >
                        Status
                      </Typography>
                      <Switch
                        checked={formData.isActive === true}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            isActive: e.target.checked,
                          }))
                        }
                      />
                    </Box>
                  </Grid>
                )}
              </React.Fragment>
            </Grid>

            <React.Fragment>
              {/* <Grid item xs={12} sm={12}>
                      <FormControl fullWidth >
                        <TextField
                          label="Salary"
                          name="salary"
                          value={formData.salary}
                          onChange={(e) => {
                            const inputValue = e.target.value;

                            // Regular expression to allow only numbers and one decimal point
                            const regex = /^[0-9]{0,10}$/;

                            // Check if the input matches the regex
                            if (regex.test(inputValue)) {
                              handleChange(e);
                            }
                          }}
                           
                          InputLabelProps={{ className: "mulish" }}
                          InputProps={{ classes: { input: "mulish" } }}
                        />
                      </FormControl>
                    </Grid> */}
            </React.Fragment>

            {/* {modalData ?.id && (


                <Grid item xs={12} sm={12} >
                  <FormGroup>
                    <FormControlLabel
                      sx={{
                        justifyContent: "space-between",
                        m: 0,
                        flexDirection: "row-reverse",
                      }}
                      control={
                        <Switch
                          checked={formData.isActive}
                          onChange={(e) => {
                             
                              setFormData({
                                ...formData, isActive:e.target.        checked
                              });

                            
                          }}
                        />
                      }
                      label="Status"
                    />
                  </FormGroup>
                </Grid>
              )

              } */}
            <Divider
              sx={{
                borderColor: "#4E4E4E",
                borderBottomWidth: 1,
                marginTop: 2,
                marginBottom: 1,
              }}
            />
            <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                type="submit"
                sx={{ width: { sm: "70%", xs: "100%" } }}
                variant="contained"
                // sx={{
                //   backgroundColor: "#3695B6",
                //   padding: "14px",
                //   fontSize: "16px",
                // }}
              >
                {modalData ? "Update" : "Save"}
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Box>
    </Modal>
  );
}
